/** @format */

export const TwitterMedium = ({color}) => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M21.9613 5.02555C21.2238 5.36541 20.4363 5.59546 19.6064 5.70134C20.4616 5.16371 21.1019 4.32052 21.4088 3.32759C20.6163 3.81123 19.7376 4.16416 18.8027 4.36022C18.186 3.66999 17.3685 3.2121 16.4773 3.05768C15.5862 2.90325 14.6712 3.06096 13.8745 3.50628C13.0779 3.9516 12.4442 4.65961 12.0718 5.5203C11.6995 6.381 11.6095 7.34619 11.8156 8.26592C10.1862 8.18371 8.59154 7.74336 7.13568 6.97356C5.67983 6.20376 4.39542 5.12179 3.36616 3.79816C2.99854 4.45157 2.80677 5.19681 2.8112 5.95492C2.8112 7.44504 3.53615 8.75478 4.63484 9.52468C3.98414 9.50318 3.34777 9.31944 2.7787 8.98876V9.04105C2.77829 10.0312 3.10541 10.991 3.70458 11.7577C4.30374 12.5244 5.13805 13.0507 6.066 13.2474C5.46492 13.4159 4.83534 13.4414 4.22361 13.3219C4.48706 14.174 4.99826 14.919 5.68592 15.4527C6.37357 15.9865 7.20339 16.2825 8.05962 16.2995C6.34469 17.708 4.16503 18.3465 2 18.0746C3.8796 19.3334 6.06513 20.0016 8.29711 20C15.8416 20 19.9626 13.4683 19.9626 7.81235C19.9626 7.62935 19.9626 7.44635 19.9501 7.26335C20.7501 6.66207 21.45 5.90394 22 5.04254L21.96 5.02555H21.9613Z"
                fill={color}
            />
        </svg>
    );
};
